import { Box, Typography } from "@mui/material"
import Page from "../../components/molecules/page"
import TableView from "../../components/atoms/table"
import { useNavigate } from "react-router-dom";
import { FetchFromBackoffice } from "../../utils/request";
import { useEffect, useState } from "react";
import { Hardware } from "@mui/icons-material";
import { DataLoadingText } from "../../components/atoms/text/dataLoadingText";
import { RecipesTable } from "./recipes";


export type VersionItem = {
    articleNo: string,
    description: string,
    state: string,
}

const HardwareVersionsTable = ({ versions }: { versions: VersionItem[] }) => {
    const navigate = useNavigate()
    return (
        <Box>
            <TableView
                items={versions}
                defaultSortColumn={'articleNo'}
                isClickable={true}
                onRowClick={item => navigate(item.articleNo)}
                columns={[
                    {
                        Property: "articleNo",
                        Title: 'Article number',
                    },

                    {
                        Property: "description",
                        Title: "Description",
                    },
                ]}>

            </TableView>
        </Box>

    )
}

export const HardwareVersionsPage = () => {
    const [versions, setVersions] = useState<VersionItem[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const getVersions = async (): Promise<Object[]> => {
        const versions = await FetchFromBackoffice<Object[]>('hardware')
        return versions
    }

    useEffect(() => {
        setIsLoading(true)
        getVersions().then(versions => {
            if (versions === undefined || versions.length === 0) {
                setVersions([])
                setIsLoading(false)
                return
            }
            const items: VersionItem[] = (versions as VersionItem[]).map(
                (r): VersionItem => {
                    return {
                        articleNo: r.articleNo,
                        description: r.description,
                        state: r.state
                    }
                }
            )
            setVersions(items)
            setIsLoading(false)
        });
    }, []);

    return (
        <Page
            title="Asset Management"
            sideScroll={ true }
            tabs={[
                    {
                      name: "Hardware versions",
                      icon: <Hardware />,
                      pageSections: [
                        isLoading ? <DataLoadingText showSpinner text={'Loading versions...'} /> : (versions.length === 0 ? <Typography>No versions found. </Typography> : <HardwareVersionsTable versions={versions}/>)
                      ],
                    },

                    {
                      name: "Recipes",
                      icon: <Hardware />,
                      pageSections: [
                        <RecipesTable/>
                      ],
                    }
            ]}>
        
        </Page>
    )
}